module.exports = __webpack_public_path__ + "img/homeIc2.5382728a.png";